/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import "normalize.css";
import Header from "components/header";
import Footer from "components/footer";
import ScrollToTop from "components/scroll_to_top";
import Style from "styles/components/layout.module.scss";
import "typeface-lato";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <div id="root">
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <main className={Style.main}>{children}</main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Layout;
